module.exports = __webpack_public_path__ + "img/10_1_1_1.6f7a62a0.png";